<template>
  <div class="container-fluid mt-4">
    <h2 class="text-center mb-4">所有权变更记录</h2>
    <div class="card p-4 bg-dark text-white">
      <div class="row">
        <div class="col-md-2">
          <div class="form-group">
            <label for="player">玩家</label>
            <input type="text" class="form-control bg-secondary text-white" id="player" v-model="filters.player" placeholder="输入玩家名称">
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="sector">区域</label>
            <input type="text" class="form-control bg-secondary text-white" id="sector" v-model="filters.sector" placeholder="输入区域">
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="grid">网格</label>
            <input type="text" class="form-control bg-secondary text-white" id="grid" v-model="filters.grid" placeholder="输入网格编号">
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="faction">派系</label>
            <input type="text" class="form-control bg-secondary text-white" id="faction" v-model="filters.faction" placeholder="输入派系">
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="startTime">开始时间</label>
            <input type="datetime-local" class="form-control bg-secondary text-white" id="startTime" v-model="filters.startTime">
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="endTime">结束时间</label>
            <input type="datetime-local" class="form-control bg-secondary text-white" id="endTime" v-model="filters.endTime">
          </div>
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-primary" @click="doFetchData">过滤</button>
      </div>
    </div>

    <div class="table-responsive mt-4">
      <div class="d-flex justify-content-between align-items-center mt-3">
        <button class="btn btn-secondary" :disabled="page === 1" @click="previousPage">上一页</button>
        <span class="text-info">第 {{ page }} 页，共 {{ totalPages }} 页 - 共 {{ totalItems }} 条记录</span>
        <button class="btn btn-secondary" :disabled="page >= totalPages" @click="nextPage">下一页</button>
      </div>
      <hr />

      <table class="table table-dark table-striped table-hover">
      <thead>
        <tr>
          <!-- <th>ID</th> -->
          <th>时间</th>
          <th>区域</th>

          <th>动作类型</th>
          <th>动作所有者</th>
          <th>块名称</th>
          <th>网格</th>

          <th>原所有者</th>
          <th>新所有者</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in ownershipChanges" :key="item.ID">
          <!-- <td class="text-nowrap">{{ item.ID }}</td> -->
          <td class="text-nowrap" width="1%">{{ item.Time }}</td>
          <td class="text-nowrap" width="1%">{{ item.Sector }}</td>

          <td class="text-nowrap" width="1%">{{ actionTypeTranslation(item.ActionType) }}</td>

          <td class="text-nowrap" width="10%">
            <span>{{ item.ActionOwner }}</span>
            {{ item.ActionOwnerFaction && "["+item.ActionOwnerFaction+"]" }}

            <i :class="[
              { 'text-success': item.ActionOwnerOnline === 'On', 'text-muted': item.ActionOwnerOnline !== 'On' },
              'fas', 'fa-circle'
            ]"></i>
          </td>
          <td class="text-nowrap" width="10%">{{ item.BlockName }}</td>
          <td class="text-nowrap" width="10%">{{ item.Grid }}</td>
          <td class="text-nowrap" width="10%">
            <span>{{ item.FromOwner }}</span>
            {{ item.FromOwnerFaction && "["+item.FromOwnerFaction+"]" }}

            <i :class="[
              { 'text-success': item.FromOwnerOnline === 'On', 'text-muted': item.FromOwnerOnline !== 'On' },
              'fas', 'fa-circle'
            ]"></i>
          </td>

          <td class="text-nowrap" width="10%">
            <span>{{ playerTranslation(item.ToOwner) }}</span>
            <i :class="[
              { 'text-success': item.ToOwnerOnline === 'On', 'text-muted': item.ToOwnerOnline !== 'On' },
              'fas', 'fa-circle'
            ]"></i>
            {{ item.ToOwnerFaction }}
          </td>


        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import axios from '../api/axios';

export default {
  data() {
    return {
      ownershipChanges: [],
      totalPages:0,
      totalItems:0,
      filters: {
        player: '',
        sector: '',
        faction: '',
        start_time: '',
        end_time: '',
        grid: ''
      },
      page: 1,
      perPage: 30
    };
  },
  methods: {
    fetchData() {
      const params = {
        ...this.filters,
        page: this.page,
        per_page: this.perPage
      };
      axios.get('/ownership_changes', { params })
        .then(response => {
          console.log('Data fetched:', response.data); // 调试信息
          this.ownershipChanges = response.data.items;
          this.totalItems = response.data.total_items;
          this.totalPages = Math.ceil(this.totalItems / this.perPage);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    },
    doFetchData() {
      this.page = 0;
      this.fetchData();
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
        this.fetchData();
      }
    },
    nextPage() {
      this.page++;
      this.fetchData();
    },
    actionTypeTranslation(actionType) {
      if (actionType.includes("owner")){
        return "所属变更";
      }
      if (actionType.includes("destroyed")){
        return "破坏";
      }
      return actionType;
    },
    playerTranslation(playername) {
      if (playername && playername.includes("Nobody")){
        return "无人";
      }
      return playername;
    }
  },
  mounted() {
    this.fetchData();
  },
  
};
</script>

<style scoped>
body {
  background-color: #222;
  color: #fff;
}
.card {
  background-color: #333;
}
.form-control {
  background-color: #555;
  color: #fff;
}
.table {
  background-color: #333;
}
</style>
